import ProductoPadre from './ProductoPadre';
export default ProductoPadre;